// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44c9a9d5","481":"ee443f7a"}[chunkId] + ".chunk.js";
};